export class TaxReClaimResponse {
  "errorCode": number;
  "errorDescription": string;
  "errorMessage": null;
  "response": {
    "returnCode": string;
    "returnMessage": string;
    "taxReclaimDetail": [
      {
        "account": string;
        "payableDate": string;
        "currencyCode": string;
        "securityName": string;
        "balanceDueAmount": number;
        "statusCode": string
      },
      {
        "account": string;
        "payableDate": string;
        "currencyCode": string;
        "securityName": string;
        "balanceDueAmount": number;
        "statusCode": string
      }
    ]
  }
}
export function naTaxReclaim(): TaxReClaimResponse {
  return {
      errorCode: 0,
      errorDescription: '',
      errorMessage: null,
      response: {
        returnCode: '',
        returnMessage: '',
        taxReclaimDetail: [
          {
            account: '',
            payableDate: '',
            currencyCode: '',
            securityName: '',
            balanceDueAmount: 0,
            statusCode: ''
          },
          {
            account: '',
            payableDate: '',
            currencyCode: '',
            securityName: '',
            balanceDueAmount: 0,
            statusCode: ''
          }
        ]
      },
  };
}